import io from "socket.io-client";
import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Button, Form, ListGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { RoomContext } from "../App";
import { NicknameContext } from "../App";
import { socket } from "../App";
import "../index.css";
import { signOut } from "firebase/auth";

import { auth, provider } from "../firebase";
import { signInWithPopup } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import { collection } from "firebase/firestore";

import { InputGroup } from "react-bootstrap";
import { Game } from "./game";
import { RoomMenu } from "./roommenu";
import { Lobby } from "./lobby";
import { Card } from "react-bootstrap";
import previewGif from "../gamePreview.gif";
import { Image } from "react-bootstrap";

import pinkPenguin from "../pinkPenguin.webp";
import sketchPenguin from "../penguin-drawing.jpg";
import pinkCloud from "../pinkCloud.png";
import { UserContext } from "../App";
import { db } from "../firebase";
import { doc, getDoc, addDoc, getDocs, updateDoc } from "firebase/firestore";
import { query, where } from "firebase/firestore";
import { useParams } from "react-router-dom";

import { InputFilesContext } from "../App";
import arrowDown from "../arrow-down-solid.svg"

export const Post = ({ id }) => {
  const [post, setPost] = useState(null);
  const navigate = useNavigate();
  const { inputFiles, setInputFiles } = useContext(InputFilesContext);
  const [sources, setSources] = useState([]);
  const [displaySources, setDisplaySources] = useState(false);

  useEffect(() => {
    console.log(id);
    const getPost = async () => {
      const q = query(collection(db, "posts"), where("id", "==", id));
      console.log(q);
      const querySnapshot = await getDocs(q);
      setSources([]);
      querySnapshot.forEach((doc) => {
        console.log(doc.data());
        setPost(doc.data());
        if (doc.data().input) {
          doc.data().input.map(async (docRef) => {
            const docSnap = await getDoc(docRef);
            console.log(docSnap.data());
            setSources((prev) => [...prev, docSnap.data()]);
          });
        }
      });
    };
    getPost();
  }, []);

  const handleFuse = () => {
    fetch(post.imgUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const file = new File([blob], "fusion.png", { type: "image/png" });
        setInputFiles([
          {
            file: file,
            id: 12,
            size: file.size,
            type: "image/png",
            name: file.name,
          },
        ]);
        console.log(file, blob);
      })
      .catch((error) => console.error(error));
  };

  const handleClickFuse = () => {
    fetch(post.imgUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const newBlob = new Blob([blob], { type: 'image/png' }); // Create new Blob with correct MIME type
        const file = new File([newBlob], "fusion.png", { type: 'image/png' }); // Pass new Blob to File constructor
        setInputFiles([
          {
            file: file,
            fid: post.id,
            size: file.size,
            type: "image/png",
            name: file.name,
            original: true,
            url: post.imgUrl,

          },
        ]);
        console.log(file, newBlob);
      })
      .catch((error) => console.error(error));
    navigate("/fuse");
  };

  const handleClickSource = () => {
    setDisplaySources(!displaySources)
  };

  return (
    <Card lol={1}>
     
        <Container>
            <Row lg={12}>
                {sources.map((source) => {
                    return (
                        <Col >
                            <Image fluid variant="top" src={source?.imgUrl} />
                        </Col>
                    )
                })}
            </Row>
        </Container>
    
        <img src={arrowDown} height="40px" ></img>
        <Image style={{height: "50%",width:"auto"}} fluid src={post?.imgUrl} />
     
      <Card.Body>
        <div onClick={() => handleClickSource()}>Source {post?.id}</div>
        <Button onClick={() => handleClickFuse()}>Fuse</Button>
      </Card.Body>
    </Card>
  );
};























